import { PeriodPreset } from "@/components/dashboard/period-preset";
import type { PeriodFiltersValue } from "@/components/dashboard/PeriodFilters";

export interface LaunchDatedCollection {
  launchDate: string | null;
}

export const defaultPeriodFilters = (now = new Date()): PeriodFiltersValue => {
  const from = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
  from.setHours(0, 0, 0, 0);
  return {
    cityIds: [],
    qrfyIds: [],
    preset: PeriodPreset.LastSevenDays,
    from,
    to: now,
  };
};

const parseCalendarDate = (value: string): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]) - 1;
  const day = Number(match[3]);
  const date = new Date(year, month, day);
  return Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
    ? null
    : date;
};

export const clientDefaultPeriodFilters = (
  collections: LaunchDatedCollection[],
  now = new Date(),
): PeriodFiltersValue => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const launchDates = collections
    .flatMap((collection) => {
      const date = collection.launchDate
        ? parseCalendarDate(collection.launchDate)
        : null;
      return date && date.getTime() <= today.getTime() ? [date] : [];
    })
    .sort((a, b) => a.getTime() - b.getTime());

  if (launchDates.length === 0) return defaultPeriodFilters(now);

  return {
    cityIds: [],
    qrfyIds: [],
    from: launchDates[0],
    to: now,
    preset: null,
  };
};
